
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/ZoneTypeApi/ZoneType.js";
import { validateForm } from "utils/validation";
import { ZoneTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditZoneTypeForm from "./components/EditZoneTypeForm";
import fields from "../json/ZoneTypeFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditZoneType = () => {
    const navigate = useNavigate();
    const { formdata } = fields;
    const { id } = useParams();

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        ZoneTypeRules
    );

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Update({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, ZoneTypeRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Zone Type updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditZoneTypeForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Update Zone Type"
            />
        </>
    );
};

export default EditZoneType;
